import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Collapse } from '../../../../common/collapse'
import { Element } from '../../../../common/html/element'
import { PopupBusinessCreditReport } from '../../../../common/popup/popupBusinessCreditReport'
import { PopupFactsheet } from '../../../../common/popup/popupFactsheet'
import { PopupFollowAlert } from '../../../../common/popup/popupFollowAlert'
import { PopupManageCompanyPortfolio } from '../../../../common/popup/popupManageCompanyPortfolio'
import EventEmitter, {
  SHOW_ORDER_BUSINESS_CREDIT_REPORT,
} from '../../../../helpers/EventEmitter'
import '../../../../lang/i18n'
import { Detail } from './detail'
import { FollowBtn } from './followBtn'
import classes from './index.module.scss'
import { MinimumAction } from './minimumAction'
import { selectCompanyInfo } from './store/slice'
import {
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from './store/thunk'

export const CompanyInfo = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const companyInfo = useSelector(selectCompanyInfo)
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getScoreRangesCreditRisk())
    dispatch(getScoreRangesPerformance())
  }, [locale])

  useEffect(() => {
    if (!!params.isOrderBl) {
      EventEmitter.dispatch(SHOW_ORDER_BUSINESS_CREDIT_REPORT, true)
    }
  }, [])

  const renderLeft = () => {
    return (
      <>
        <Element
          elementName="p"
          style={{
            fontSize: 24,
            color: '#0553a5',
            fontWeight: 600,
          }}
        >
          {companyInfo.organizationName}
        </Element>
      </>
    )
  }

  const renderRight = (isCollapse) => {
    return !isCollapse ? (
      <div className="dFlex" style={{ alignSelf: 'flex-start' }}>
        <MinimumAction />
      </div>
    ) : (
      <FollowBtn isFollowed={companyInfo.isFollowed} />
    )
  }

  return (
    <>
      <div className={classes.container}>
        <Element
          className={classes.content}
          style={{ borderBottomColor: '#e5e5e8' }}
        >
          <Collapse
            isOpen={true}
            scrollIdToCollapse="companyAnalysis"
            renderLeft={renderLeft}
            renderRight={renderRight}
            isToggleIconOnly
            iconStyle={{
              alignSelf: 'flex-start',
              marginRight: 4,
              marginLeft: 12,
              position: 'relative',
              top: 6,
            }}
            style={{
              backgroundColor: '#FFFFFF',
              cursor: 'default',
              padding: 0,
            }}
          >
            <div className={classes.collapseContent}>
              {Object.keys(companyInfo).length > 0 && (
                <Detail data={companyInfo} />
              )}
            </div>
          </Collapse>
        </Element>
      </div>
      <PopupBusinessCreditReport />
      <PopupFactsheet />
      <PopupManageCompanyPortfolio />
      <PopupFollowAlert />
    </>
  )
}
